import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";

import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
// namespace SlotGames
// {
	export class JuicyIce_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp
	{
		// override default factory with one that creates custom icy fresh freegame
		////protected override freegameBonusFactory_2Screen: FreegameBonusFactory_2Screen = new JuicyIceFreegameBonusFactory2();
		protected override pickBonusFactory:PickBonusFactory = new JuicyIcePickBonusFactory();
		

	
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) 
		{
				super(multigameParams, initData, "JuicyIce");
			this.spinnableReelsParams.topBorderWidth=0;
			this.spinnableReelsParams.bottomBorderWidth=0;
		}

		// public PrepareFont(resourceManager: ResourceManager)
		// {
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", "."+ this.resid.ScopedResourceName("font")));
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", "."+ this.resid.ScopedResourceName(["lines", "font"])));
		// }
	}

	/***************************************************************************
		ICY FRESH FREEGAME
	***************************************************************************/
	
	

	// class JuicyIceFreegameBonusFactory_2Screen extends FreegameBonus_2Screen 
	// {
	// 	public constructor(gameName: string, params: FreegameBonusParams ) {
	// 		super(gameName, params);
	// 		this.spinnableReelsParams.topBorderWidth = 0;
	// 		this.spinnableReelsParams.bottomBorderWidth = 0;
	// 	}
	// 	protected override PicksPositions(): FreegamePickElemGeometry[] 
	// 	{
	// 		let geometry: FreegamePickElemGeometry[] = [];

	// 		let displayWidth: number = 540;
	// 		let displayHeight: number = 510;

	// 		let displayRects: Rect[] = 
	// 		[
	// 			new Rect(21, 328, displayWidth, displayHeight),
	// 			new Rect(363, 528, displayWidth, displayHeight),
	// 			new Rect(705, 328, displayWidth, displayHeight),
	// 			new Rect(1044, 528, displayWidth, displayHeight),
	// 			new Rect(1386, 328, displayWidth, displayHeight),
	// 		];

	// 		// offset relative to pick rect
	// 		let pickRect = new Rect(207,161,124,287);
	// 		let awardRect = new Rect(207,161,124,287);

	// 		for (let i = 0; i < displayRects.length; i++) 
	// 		{
	// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect, awardRect));
	// 		}

	// 		return geometry;
	// 	}

	// 	public override OnPicked(index: number): void {
	// 		//super.OnPicked(index);

	// 		if (this.stateMachine.State() == FreegameStates.Pick)
	// 		{
	// 			// Log.Debug(this.logGroup, "Picked index " + index);
	
	// 			// TODO check state, check index bounds
	// 			this.pickedIndex = index;
	// 			// protocol.Send("SelectBonusElement",{selectedElement: index});
	
	// 			for (let i = 0; i < this.picks.length; i++) {
	// 				if (i == index) {
	// 					this.picks[i].BringToFront();
	// 					this.picks[i].awardElem.style.fontSize = "90px";
	// 					this.picks[i].awardElem.style.left = "205px";
	// 					this.picks[i].awardElem.style.top = "90px";
	// 				}
					
	// 				else {
	// 					this.picks[i].PushToBack();
	// 					this.picks[i].awardElem.style.left = "205px";
	// 					this.picks[i].awardElem.style.top = "90px";
	// 				}
	// 			}
	
	// 			this.stateMachine.ChangeState(FreegameStates.RevealPicked);
	// 		}
	// 	}

	// 	public override ResourcesLoaded(resourceManager: ResourceManager)
	// 	{
	// 		super.ResourcesLoaded(resourceManager);
            
	// 		//this.pickElem.innerHTML = "BOTTLE";


	// 		// this.introMessageContainer.style.color = "yellow";
	// 		// this.introMessageContainer.style.webkitTextStrokeWidth = "2px";
	// 		// this.introMessageContainer.style.webkitTextStrokeColor = "black";
	// 		// this.finalMessageContainer.style.textShadow="black 0px 1px 1px, black 0px 1px 17px, black 0px 1px 21px, black 0px 1px 2px";
			
	// 		// this.pickedMessageContainer.style.webkitTextStrokeWidth="2px";
	// 		// this.pickedMessageContainer.style.webkitTextStrokeColor = "black"
	// 		// this.pickedMessageContainer.style.textShadow="black 0px 1px 1px, black 0px 1px 17px, black 0px 1px 21px, black 0px 1px 2px";
	// 		// this.finalMessageContainer.style.webkitTextStrokeWidth="2px";
	// 		// this.finalMessageContainer.style.webkitTextStrokeColor = "black";
	// 		// this.finalMessageContainer.style.textShadow="black 0px 1px 1px, black 0px 1px 17px, black 0px 1px 21px, black 0px 1px 2px";
				
	// 		// SetStyles(this.view.querySelector("#startfree3"), { fontSize:"35px" });
	// 		// SetStyles(this.view.querySelector("#contents3"), { fontSize:"35px" });
	// 		// SetStyles(this.view.querySelector(".header"), { fontSize:"70px" });
	// 		// SetStyles(this.view.querySelector(".bonusName").parentElement, { fontSize:"60px", lineHeight: "100px", });
	// 		// SetStyles(this.view.querySelector("#startfree1"), { fontSize:"40px" });
	// 		// SetStyles(this.view.querySelector("#startfree2"), { fontSize:"40px" });
	// 		// SetStyles(this.view.querySelector("#contents1"), { fontSize:"40px", lineHeight: "40px" });
	// 		// SetStyles(this.view.querySelector("#contents2"), { fontSize:"40px", lineHeight: "40px" });
	// 		// SetStyles(this.view.querySelector("#headerend"), { fontSize:"73px" });
	// 		// SetStyles(this.view.querySelector("#startend3"), { fontSize:"36px" });

	// 		// // pick instructions on pick screen
	// 		// SetStyles(this.view.querySelector(".pickInstructions .pick1"), {lineHeight: "100px"});
	// 	}

	// 	protected override PrepareFonts(resourceManager: ResourceManager): void {
	// 		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "Melting Letter.ttf", "." + this.resid.ScopedResourceName("font") ));
	// 		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "Melting Letter.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
	// 	}
	// }

	class JuicyIceFreegamePickElement extends FreegamePickElement
	{
		
		public override AwardElemePrepare()
		{
			super.AwardElemePrepare();
			this.awardElem.style.left = "70px";
			this.awardElem.style.top = "15px";
			this.awardElem.style.fontSize ="50px";
		}

		
	}


	//Here is the class for pick elemnt
	



	/**
	 * PICK BONUS
	 */
	class JuicyIcePickBonus extends PickBonus
	{
		/* protected PicksPositions():PickBonusElemGeometry[]
		{
			let geometry: PickBonusElemGeometry[] = [];

			let displayWidth: number = 256;//285 * 0.60;
			let displayHeight: number = 261;//325 * 0.60;

			let displayRects: Rect[] = 
			[
				new Rect(86,14, displayWidth, displayHeight),
				new Rect(65,316, displayWidth, displayHeight),
				new Rect(38,649, displayWidth, displayHeight),
				new Rect(61,493, displayWidth, displayHeight),
				new Rect(80,163, displayWidth, displayHeight),
				new Rect(212,240, displayWidth, displayHeight),
				new Rect(230,91, displayWidth, displayHeight),
				new Rect(212,550, displayWidth, displayHeight),
				new Rect(205,402, displayWidth, displayHeight),
				new Rect(180,691, displayWidth, displayHeight),
				new Rect(344,655, displayWidth, displayHeight),
				new Rect(370,355, displayWidth, displayHeight),
				new Rect(361,171, displayWidth, displayHeight),
				new Rect(414,31, displayWidth, displayHeight),
				new Rect(499,239, displayWidth, displayHeight),
				new Rect(409,499, displayWidth, displayHeight),
				new Rect(518,698, displayWidth, displayHeight),
				new Rect(572,543, displayWidth, displayHeight),
				new Rect(556,381, displayWidth, displayHeight),
				new Rect(592,105, displayWidth, displayHeight),
				new Rect(661,209, displayWidth, displayHeight),
				new Rect(740,503, displayWidth, displayHeight),
				new Rect(725,661, displayWidth, displayHeight),
				new Rect(767,33, displayWidth, displayHeight),
				new Rect(793,187, displayWidth, displayHeight),
				new Rect(729,353, displayWidth, displayHeight),
				new Rect(898,535, displayWidth, displayHeight),
				new Rect(903,702, displayWidth, displayHeight),
				new Rect(1074,638, displayWidth, displayHeight),
				new Rect(1235,689, displayWidth, displayHeight),
				new Rect(1201,531, displayWidth, displayHeight),
				new Rect(1043,455, displayWidth, displayHeight),
				new Rect(1099,289, displayWidth, displayHeight),
				new Rect(970,181, displayWidth, displayHeight),
				new Rect(1363,521, displayWidth, displayHeight),
				new Rect(1527,679, displayWidth, displayHeight),
				new Rect(1382,665, displayWidth, displayHeight),
				new Rect(1588,534, displayWidth, displayHeight),
				new Rect(1425,383, displayWidth, displayHeight),
				new Rect(1251,381, displayWidth, displayHeight),
				new Rect(916,360, displayWidth, displayHeight),
				new Rect(1126,102, displayWidth, displayHeight),
				new Rect(965,27, displayWidth, displayHeight),
				new Rect(1581,364, displayWidth, displayHeight),
				new Rect(1571,200, displayWidth, displayHeight),
				new Rect(1412,220, displayWidth, displayHeight),
				new Rect(1248,218, displayWidth, displayHeight),
				new Rect(1281,36, displayWidth, displayHeight),
				new Rect(1596,42, displayWidth, displayHeight),
				new Rect(1436,57, displayWidth, displayHeight)
			];


			//
			//let pickRect = new Rect(displayWidth, displayHeight, displayWidth, displayHeight);
			//pick area
			let pickRect = new Rect(85, 91, 93, 87);
			

			//let awardRect = new Rect(64, 114, 66, 64);
			//award display area
			let awardRect = new Rect(81, 85, 87, 70);

			for (let i = 0; i < displayRects.length; i++) {
				geometry.push(new PickBonusElemGeometry(displayRects[i], pickRect, awardRect));
			}

			return geometry;

		} 
 */
		

	}

	class JuicyIcePickBonusElement extends PickBonusElement
	{
		public override AwardElemePrepare()
		{
			super.AwardElemePrepare();
			
			/* this.awardElem.style.left = this.awardRect.x +"px";
			this.awardElem.style.top = this.awardRect.y+10 + "px";
			this.awardElem.style.width = this.awardRect.width + "px";
			this.awardElem.style.height = this.awardRect.height + "px"; */
		}
		/* public WaitAnimPick()
		{
			this.anim_waitpick = TweenMax.fromTo(this, 1, {myscale: 1}, {myscale: 1.2, yoyo: true, repeat: -1, ease: Power0.easeNone, paused: true});
		} */
	}

	class JuicyIcePickBonusFactory extends PickBonusFactory
	{
		public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus 
		{
			return new JuicyIcePickBonus(gameName, params);
		}

		public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement 
		{
			return new JuicyIcePickBonusElement(params);
		}
		
	}

	// class JuicyIceFreegameBonusFactory2 extends FreegameBonusFactory_2Screen
	// {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus_2Screen 
	// 	{
	// 		return new JuicyIceFreegameBonusFactory_2Screen(gameName, params);
	// 	}
	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement 
	// 	{
	// 		return new JuicyIceFreegamePickElement(params);
	// 	}


	// }
	
// }
